import React, { useState } from "react";
import { Modal } from "@/components/Modal";
import { ABtn, AResult } from "@/components/games/arcadeUi";

const FLAV = [
  { k: "khatta", l: "Kaala Khatta", c: "#4b006e" },
  { k: "orange", l: "Orange", c: "#ff7a00" },
  { k: "rose", l: "Rose", c: "#e63980" },
  { k: "lemon", l: "Lemon", c: "#a9b800" },
];

export const GolaMaker = ({ open, onClose }) => {
  const [flavor, setFlavor] = useState(null);
  const [poured, setPoured] = useState(false);
  const [slurp, setSlurp] = useState(0);
  if (!open) return null;
  const done = slurp >= 100;

  const reset = () => { setFlavor(null); setPoured(false); setSlurp(0); };

  return (
    <Modal open={open} onClose={onClose} testId="gola-modal" maxWidth="max-w-md">
      <div className="p-6 text-center">
        <h2 className="font-signboard text-2xl font-bold text-kirana-brown">🧊 Gola Wala — Barf ka gola</h2>
        <p className="mt-1 text-sm text-kirana-brown/70">
          {!flavor ? "Flavour choose karo" : !poured ? "Ab syrup daalo" : done ? "Khatam! 😋" : "Ab maze se pio — tap to slurp!"}
        </p>

        <div className="relative mx-auto my-5 h-48 w-28">
          <div className="absolute left-1/2 top-1 h-24 w-1.5 -translate-x-1/2 rotate-6 rounded bg-kirana-red" />
          <div className="absolute left-1/2 top-8 -translate-x-1/2 rounded-full border border-black/10"
            data-testid="gola-ice"
            style={{ width: 84, height: 84, background: poured && flavor ? flavor.c : "#eef4f7", transition: "all .25s", transform: `scale(${Math.max(0.05, 1 - slurp / 130)})`, opacity: done ? 0 : 1 }} />
          <div className="absolute bottom-0 left-1/2 h-0 w-0 -translate-x-1/2 border-x-[32px] border-t-[74px] border-x-transparent border-t-[#c98a3a]" />
        </div>

        {!flavor ? (
          <div className="flex flex-wrap justify-center gap-2">
            {FLAV.map((f) => (
              <ABtn key={f.k} data-testid={`gola-flavor-${f.k}`} onClick={() => setFlavor(f)} tone="gold">{f.l}</ABtn>
            ))}
          </div>
        ) : !poured ? (
          <ABtn data-testid="gola-pour" onClick={() => setPoured(true)} tone="red" className="px-8">Pour {flavor.l} syrup</ABtn>
        ) : !done ? (
          <ABtn data-testid="gola-slurp" onClick={() => setSlurp((s) => Math.min(100, s + 25))} tone="red" className="px-10 py-3 text-lg">Slurp! 😛</ABtn>
        ) : (
          <>
            <AResult testId="gola-result" win text="Aah, thanda-thanda! 😋" />
            <div className="mt-3 flex justify-center"><ABtn data-testid="gola-again" onClick={reset} tone="green">Ek aur banao</ABtn></div>
          </>
        )}
      </div>
    </Modal>
  );
};
